import { Dialog } from "@headlessui/react";

export default function ScannedItemEditDeleteModal(props) {
  const { scannedItem, setOpen, onEdit, onDelete } = props;

  const handleCancel = () => {
    setOpen({
      childComponent: null,
      open: false,
    });
  };

  const handleEdit = () => {
    onEdit(scannedItem);
  };

  const handleDelete = () => {
    onDelete(scannedItem);
  };

  const getBarcodeLast9 = (barcode) => {
    if (!barcode) return "N/A";
    return barcode.slice(-9);
  };

  return (
    <div>
      <div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-medium font-bold leading-6 text-gray-900"
          >
            Barcode: {getBarcodeLast9(scannedItem?.barcode)}
          </Dialog.Title>
          <div className="mt-4">
            <p className="text-sm text-gray-600 font-semibold">
              Amount Used: {scannedItem?.ingredient_amount_used || 0}{" "}
              {scannedItem?.unit_of_measure || ""}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 grid grid-flow-row-dense grid-cols-2 gap-2">
        <button
          type="button"
          className="mt-3 inline-flex w-full justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2 sm:mt-0"
          onClick={handleEdit}
        >
          Edit
        </button>
        <button
          type="button"
          className="mt-3 inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 sm:col-start-3 sm:mt-0"
          onClick={handleDelete}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
